module.exports = __webpack_public_path__ + "media/jq_pano.b29e2999.mp4";